/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ea-type-container[_ngcontent-%COMP%]{margin-top:25px;margin-bottom:25px}"];
export { styles as styles };
